import React from 'react'

import { array, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import CollectionModelGrid from './CollectionGrid/CollectionModelGrid/CollectionModelGrid'

function CollectionGridSection({
  slug,
  initialModels = EMPTY_ARRAY,
}) {
  return (
    <div className="collection-grid-section">
      <CollectionModelGrid
        models={initialModels}
        collectionSlug={slug}
      />
    </div>
  )
}

CollectionGridSection.propTypes = {
  slug: string.isRequired,
  initialModels: array,
}

export default CollectionGridSection
